import { render, staticRenderFns } from "./DatesPage.vue?vue&type=template&id=27e6b40b&scoped=true&"
import script from "./DatesPage.vue?vue&type=script&lang=js&"
export * from "./DatesPage.vue?vue&type=script&lang=js&"
import style0 from "./DatesPage.vue?vue&type=style&index=0&id=27e6b40b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e6b40b",
  null
  
)

export default component.exports